import { render, staticRenderFns } from "./BindMail.vue?vue&type=template&id=71428c52&scoped=true&"
import script from "./BindMail.vue?vue&type=script&lang=js&"
export * from "./BindMail.vue?vue&type=script&lang=js&"
import style0 from "./BindMail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BindMail.vue?vue&type=style&index=1&id=71428c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71428c52",
  null
  
)

export default component.exports